var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "ma-0 pa-0" },
      [
        _c(
          "v-row",
          {
            staticClass: "mb-6",
            attrs: { "no-gutters": "", justify: "start" },
          },
          [
            _c(
              "v-col",
              { attrs: { cols: "3", sm: "2", md: "3" } },
              [
                _c("v-text-field", {
                  staticClass: "px-3 pb-1",
                  attrs: {
                    "prepend-inner-icon": "mdi-magnify",
                    hint: "Filter on file name (partial or multiple values)",
                    placeholder: "file name",
                    clearable: "",
                    "hide-details": "auto",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.allFieldsCleared()
                    },
                    "click:clear": function ($event) {
                      return _vm.clearSearchItemsClicked()
                    },
                  },
                  model: {
                    value: _vm.searchItems,
                    callback: function ($$v) {
                      _vm.searchItems = $$v
                    },
                    expression: "searchItems",
                  },
                }),
              ],
              1
            ),
            _c(
              "v-col",
              { attrs: { cols: "3", sm: "2", md: "3" } },
              [
                _c("v-text-field", {
                  staticClass: "px-3 pb-1",
                  attrs: {
                    "prepend-inner-icon": "mdi-magnify",
                    hint: "Filter on group name (partial or multiple values)",
                    placeholder: "group name",
                    clearable: "",
                    "hide-details": "auto",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.allFieldsCleared()
                    },
                    "click:clear": function ($event) {
                      return _vm.clearSearchGroupsClicked()
                    },
                  },
                  model: {
                    value: _vm.searchGroups,
                    callback: function ($$v) {
                      _vm.searchGroups = $$v
                    },
                    expression: "searchGroups",
                  },
                }),
              ],
              1
            ),
            _c(
              "v-col",
              { attrs: { cols: "2", sm: "2", md: "3" } },
              [
                _c("v-text-field", {
                  staticClass: "px-3 pb-1",
                  attrs: {
                    "prepend-inner-icon": "mdi-magnify",
                    hint: "Filter on tag name (partial or multiple values)",
                    placeholder: "tag name",
                    clearable: "",
                    "hide-details": "auto",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.allFieldsCleared()
                    },
                    "click:clear": function ($event) {
                      return _vm.clearSearchTagsClicked()
                    },
                  },
                  model: {
                    value: _vm.searchTags,
                    callback: function ($$v) {
                      _vm.searchTags = $$v
                    },
                    expression: "searchTags",
                  },
                }),
              ],
              1
            ),
            _c(
              "v-col",
              { attrs: { cols: "2", sm: "1", md: "2" } },
              [
                _c(
                  "v-radio-group",
                  {
                    attrs: { row: "" },
                    model: {
                      value: _vm.logicOperator,
                      callback: function ($$v) {
                        _vm.logicOperator = $$v
                      },
                      expression: "logicOperator",
                    },
                  },
                  [
                    _c("v-radio", {
                      attrs: { value: "AND" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", [
                                _c(
                                  "strong",
                                  { staticClass: "page-of-pages-div" },
                                  [_vm._v("AND")]
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                    _c("v-radio", {
                      attrs: { value: "OR" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _c("div", [
                                _c(
                                  "strong",
                                  { staticClass: "page-of-pages-div" },
                                  [_vm._v("OR")]
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "v-col",
              {
                staticClass: "ml-n3 pt-4",
                attrs: { cols: "1", sm: "1", md: "1" },
              },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { depressed: "", color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.executeSearch()
                      },
                    },
                  },
                  [_vm._v(" Search ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("ActionDialog", {
          attrs: { type: "file" },
          on: {
            cancel: function ($event) {
              _vm.deleteItemDialog = false
            },
            confirm: _vm.deleteItemConfirm,
          },
          model: {
            value: _vm.deleteItemDialog,
            callback: function ($$v) {
              _vm.deleteItemDialog = $$v
            },
            expression: "deleteItemDialog",
          },
        }),
        _c(
          "div",
          { staticClass: "d-flex flex-column" },
          [
            _c(
              "v-data-table",
              {
                staticClass: "pb-8 table",
                attrs: {
                  "data-cy": "loadDatabaseFileList",
                  dense: "",
                  "fixed-header": "",
                  "mobile-breakpoint": "0",
                  "show-select": "",
                  "disable-pagination": "",
                  headers: _vm.headers,
                  page: _vm.page,
                  options: _vm.pagination,
                  items: _vm.evaluationsLoaded,
                  "server-items-length": _vm.evaluationsCount,
                  loading: _vm.loading,
                  "item-key": _vm.fileKey,
                  "items-per-page": _vm.totalItemsPerPage,
                  height: _vm.tableHight,
                  "header-props": _vm.headerprops,
                  "sort-by": _vm.pagination.sortBy,
                  "sort-desc": _vm.pagination.sortDesc,
                  "must-sort": "",
                  "footer-props": {
                    showFirstLastPage: true,
                    firstIcon: "mdi-page-first",
                    lastIcon: "mdi-page-last",
                    prevIcon: "mdi-chevron-left-circle-outline",
                    nextIcon: "mdi-chevron-right-circle-outline",
                    itemsPerPageOptions: [10, 50, 250, 500, 1000],
                    itemsPerPageText: "Rows per page:",
                  },
                },
                on: {
                  "update:page": [
                    function ($event) {
                      _vm.page = $event
                    },
                    _vm.updateDisplayPage,
                  ],
                  "update:options": function ($event) {
                    _vm.pagination = $event
                  },
                  "update:sortBy": function ($event) {
                    return _vm.$set(_vm.pagination, "sortBy", $event)
                  },
                  "update:sort-by": [
                    function ($event) {
                      return _vm.$set(_vm.pagination, "sortBy", $event)
                    },
                    _vm.updateSortBy,
                  ],
                  "update:items-per-page": _vm.updateItemsPerPage,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `header.filename`,
                      fn: function ({ header }) {
                        return [
                          _vm._v(" " + _vm._s(header.text.toUpperCase()) + " "),
                          header.sortable
                            ? _c(
                                "v-icon",
                                {
                                  staticClass:
                                    "v-data-table-header__icon page-of-pages-div",
                                  attrs: { medium: "" },
                                },
                                [_vm._v(" mdi-sort ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `header.groups`,
                      fn: function ({ header }) {
                        return [
                          _vm._v(" " + _vm._s(header.text.toUpperCase()) + " "),
                          header.sortable
                            ? _c(
                                "v-icon",
                                {
                                  staticClass:
                                    "v-data-table-header__icon page-of-pages-div",
                                  attrs: { medium: "" },
                                },
                                [_vm._v(" mdi-sort ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `header.evaluationTags`,
                      fn: function ({ header }) {
                        return [
                          _vm._v(" " + _vm._s(header.text.toUpperCase()) + " "),
                          header.sortable
                            ? _c(
                                "v-icon",
                                {
                                  staticClass:
                                    "v-data-table-header__icon page-of-pages-div",
                                  attrs: { medium: "" },
                                },
                                [_vm._v(" mdi-sort ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `header.createdAt`,
                      fn: function ({ header }) {
                        return [
                          _vm._v(" " + _vm._s(header.text.toUpperCase()) + " "),
                          header.sortable
                            ? _c(
                                "v-icon",
                                {
                                  staticClass:
                                    "v-data-table-header__icon page-of-pages-div",
                                  attrs: { medium: "" },
                                },
                                [_vm._v(" mdi-sort ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `header.actions`,
                      fn: function ({ header }) {
                        return [
                          _vm._v(" " + _vm._s(header.text.toUpperCase()) + " "),
                          header.sortable
                            ? _c(
                                "v-icon",
                                {
                                  staticClass:
                                    "v-data-table-header__icon page-of-pages-div",
                                  attrs: { medium: "" },
                                },
                                [_vm._v(" mdi-sort ")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "footer",
                      fn: function ({ props }) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "pr-10 text-right page-of-pages-div",
                            },
                            [
                              _c("b", [
                                _vm._v(
                                  " Page " +
                                    _vm._s(_vm.page.toLocaleString()) +
                                    " of " +
                                    _vm._s(
                                      props.pagination.pageCount == 0
                                        ? 1
                                        : props.pagination.pageCount.toLocaleString()
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: `footer.page-text`,
                      fn: function (items) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(items.pageStart.toLocaleString()) +
                              " - " +
                              _vm._s(items.pageStop.toLocaleString()) +
                              " of " +
                              _vm._s(items.itemsLength.toLocaleString()) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.filename`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "cursor-pointer",
                              on: {
                                click: function ($event) {
                                  return _vm.emit_selected([item])
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(item.filename) + " ")]
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.groups`,
                      fn: function ({ item }) {
                        return [
                          item.id
                            ? _c("GroupRow", { attrs: { evaluation: item } })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `item.evaluationTags`,
                      fn: function ({ item }) {
                        return [
                          item.id
                            ? _c("TagRow", {
                                attrs: {
                                  evaluation: item,
                                  "on-loading-panel": true,
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `item.createdAt`,
                      fn: function ({ item }) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(new Date(item.createdAt).toLocaleString())
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.actions`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-row",
                            { staticClass: "d-flex flex-row-reverse" },
                            [
                              _vm.editEvaluationDialog
                                ? _c("EditEvaluationModal", {
                                    attrs: {
                                      id: "editEvaluationModal",
                                      active: _vm.activeItem,
                                      visible:
                                        _vm.editEvaluationDialog &&
                                        _vm.activeItem.id === item.id,
                                    },
                                    on: {
                                      close: function ($event) {
                                        _vm.editEvaluationDialog = false
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _c("CopyButton", {
                                attrs: {
                                  text: _vm.createShareLink(item),
                                  icon: "mdi-share-variant",
                                  tooltip:
                                    "Copy evaluation link (URL) to the clipboard",
                                },
                              }),
                              item.editable
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            "data-cy": "edit",
                                            small: "",
                                            title:
                                              "Edit record (name, visibility, groups)",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editItem(item)
                                            },
                                          },
                                        },
                                        [_vm._v(" mdi-pencil ")]
                                      ),
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            "data-cy": "delete",
                                            small: "",
                                            title:
                                              "Delete record from the database",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteItem(item)
                                            },
                                          },
                                        },
                                        [_vm._v("mdi-delete")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selectedFiles,
                  callback: function ($$v) {
                    _vm.selectedFiles = $$v
                  },
                  expression: "selectedFiles",
                },
              },
              [
                _c("template", { slot: "no-data" }, [
                  _c(
                    "div",
                    {
                      staticClass: "title font-weight-light page-of-pages-div",
                    },
                    [
                      _c("b", [
                        _vm._v(
                          "No data found - try changing the search filter(s)"
                        ),
                      ]),
                    ]
                  ),
                ]),
              ],
              2
            ),
            _c(
              "v-tooltip",
              {
                attrs: { top: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              {
                                staticClass: "card-outter",
                                attrs: { block: "", disabled: _vm.loading },
                                on: {
                                  click: function ($event) {
                                    return _vm.emit_selected(_vm.selectedFiles)
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _vm._v(" Load Selected "),
                            _c("v-icon", { staticClass: "pl-2" }, [
                              _vm._v(" mdi-file-download"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              },
              [_c("span", [_vm._v("Load selected item(s)")])]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }